import { useStore } from 'effector-react';
import { styled } from 'linaria/react';
import React from 'react';
import { codeSetCursor } from '../editor';
import { $stats } from '../realm/state';
const OutlineWrapper = /*#__PURE__*/styled("div")({
  name: "OutlineWrapper",
  class: "otna9zr"
});
const Header = /*#__PURE__*/styled("div")({
  name: "Header",
  class: "h1jg9864"
});
const Section = /*#__PURE__*/styled("section")({
  name: "Section",
  class: "s9izc4l"
});
const EmptySection = /*#__PURE__*/styled("section")({
  name: "EmptySection",
  class: "edf5t6i"
});
const Item = /*#__PURE__*/styled("li")({
  name: "Item",
  class: "i1jp65yz",
  vars: {
    "i1jp65yz-0": [(props: any) => Boolean(props.loc) ? 'pointer' : 'inherit']
  }
});

const OutlineSection = ({
  list,
  title
}) => {
  if (list.length === 0) return null;
  return <>
      <Header>{title}</Header>
      <Section>
        <ol>
          {list.filter(Boolean).map((item, i) => {
          const loc = item?.defaultConfig?.loc;
          const name = item?.compositeName?.fullName || item?.shortName || item.id || item.displayName;
          const key = item.kind && item.id ? item.kind + item.id + name : name;

          const onClick = () => {
            if (loc) codeSetCursor(loc);
          };

          return <Item loc={loc} onClick={onClick} key={`${key} ${i}`}>
                {name}
              </Item>;
        })}
        </ol>
      </Section>
    </>;
};

export function Outline() {
  const {
    component,
    domain,
    event,
    effect,
    store
  } = useStore($stats);
  const isEmpty = event.length === 0 && effect.length === 0 && store.length === 0 && domain.length === 0 && component.length === 0;
  return <OutlineWrapper id="outline-sidebar">
      {isEmpty && <EmptySection>Symbols weren&apos;t found in this file</EmptySection>}
      <OutlineSection list={event} title="Events" />
      <OutlineSection list={effect} title="Effects" />
      <OutlineSection list={store} title="Stores" />
      <OutlineSection list={domain} title="Domains" />
      <OutlineSection list={component} title="Components" />
    </OutlineWrapper>;
}